export default __webpack_public_path__ + "static/userJoin1-333fe3b5b28ddaee9553e3710e82f64e.jpg";